import { List } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgQueue = mkIcon(List);
